import type { DeepPartial } from '@luna/utils-ts';

import type { Search } from '../../types/Search';

export const searchCZFeatureConfig: DeepPartial<Search> = {
    countryProductId: 'INVEST',
    displayIssuerForShares: true,
    extraGroupTypeKeys: ['PREMIUM_DEPOSIT'],
    showExperienceProfileMissingTooltip: true,
    showPreorderScreenOnSuggestionClick: true,
};
